/* Loma — header dissolves on scroll, leaving the logo and icons */
(function () {
  var THRESHOLD = 24;
  var root = document.documentElement;
  var ticking = false;

  function apply() {
    var scrolled = (window.scrollY || window.pageYOffset) > THRESHOLD;
    root.classList.toggle('loma-scrolled', scrolled);
    ticking = false;
  }
  function onScroll() {
    if (!ticking) { window.requestAnimationFrame(apply); ticking = true; }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  apply();
})();
